

var obj_3d, mixer, scene, camera, renderer, controls

//for looking at mouse
var target = new THREE.Vector3();
var mouseX = 0, mouseY = 0;
var windowHalfX = window.innerWidth / 2;
var windowHalfY = window.innerHeight / 2;

function onDocumentMouseMove( event ) {

    mouseX = ( event.clientX - windowHalfX );
    mouseY = ( event.clientY - windowHalfY );

}
window.addEventListener("mousemove", onDocumentMouseMove, false);


document.addEventListener("DOMContentLoaded", () => {
  start()
});


window.scrub_mixer_to = function(percent){

  if (!mixer) return

  var anim_duration = 11.0
  var this_time = anim_duration * (percent/100.0)

  mixer.setTime( this_time )
}


async function load_model(){

  var content = await fetch(window.box_3d.asset_url);
  var scene_json = await content.json()

  //console.log(scene_json);

  const this_scene = new THREE.ObjectLoader().parse( scene_json );

  scene.add(this_scene);


  //find the camera
  var cam_test = scene.getObjectByName("Main");
  camera = cam_test
  var box_3d_el = document.querySelector(".box-3d")
  camera.aspect = box_3d_el.offsetWidth / box_3d_el.offsetHeight
  camera.updateProjectionMatrix()


  controls = new THREE.OrbitControls(camera, renderer.domElement)
  controls.enableZoom = false
  controls.minPolarAngle = 0.4
  controls.maxPolarAngle = 1
  controls.autoRotate = true
  controls.enableDamping = true
  controls.target = new THREE.Vector3(0,0.15,0)



}


function setup_scroll_ties(){

  window.rolltide = new ScrollTide({})
  window.scrolltied = window.rolltide


  const lines_anime = anime({
    targets: '.image-features .a-feature .line',
    easing: 'linear',
    width: "calc(100% - 210px)",
    duration: 60,
    autoplay: false,
    delay: anime.stagger(10)
  });

  var lines_scroller = new Scroller({
    id:"spacer",
    container:document.querySelectorAll(".main-split")[0],
    window_offset:0.0,
    el_start:0,
    el_end:0.7,
    anime:lines_anime
  })

  rolltide.add(lines_scroller)




  const label_anime = anime({
    targets: '.image-features .a-feature .label',
    easing: 'linear',
    opacity: 1,
    translateX: [-20,0],
    duration: 60,
    autoplay: false,
    delay: anime.stagger(10)
  });

  var lines_scroller = new Scroller({
    id:"spacer",
    container:document.querySelectorAll(".main-split")[0],
    window_offset:0.0,
    el_start:0,
    el_end:0.7,
    anime:label_anime
  })

  rolltide.add(lines_scroller)





  const value_anime = anime({
    targets: '.image-features .a-feature .value',
    easing: 'linear',
    opacity: 1,
    translateY: [20,0],
    duration: 60,
    delay: anime.stagger(10),
    autoplay: false
  });
  var value_scroller = new Scroller({
    id:"spacer",
    container:document.querySelectorAll(".main-split")[0],
    window_offset:0.0,
    el_start:0,
    el_end:0.7,
    anime:value_anime,
    delay: anime.stagger(10)
  })

  rolltide.add(value_scroller)
        



  const icon_anime = anime({
    targets: '.image-features .a-feature .accent-image',
    easing: 'linear',
    opacity: 1,
    duration: 60,
    autoplay: false
  });
  var icon_scroller = new Scroller({
    id:"spacer",
    container:document.querySelectorAll(".main-split")[0],
    window_offset:0.0,
    el_start:0,
    el_end:0.7,
    anime:icon_anime,
    delay: anime.stagger(10)
  })

  rolltide.add(icon_scroller)
      


  const bag_top_anime = anime({
    targets: '.main-split .right .lid',
    easing: 'linear',
    opacity: 1,
    translateY: "-100vh",
    duration: 60,
    autoplay: false
  });
  var bag_top_scroller = new Scroller({
    id:"spacer",
    container:document.querySelectorAll(".main-split")[0],
    window_offset:0.0,
    el_start:0,
    el_end:0.7,
    anime:bag_top_anime
  })
  rolltide.add(bag_top_scroller)



  const bag_bottom_anime = anime({
    targets: '.main-split .right .base',
    easing: 'linear',
    opacity: 1,
    keyframes:[
      {translateY: 0, duration:0},
      {translateY: "100vh", duration:90},
      {opacity: "0", duration:10},
    ],
    duration: 60,
    autoplay: false
  });
  var bag_bottom_scroller = new Scroller({
    id:"spacer",
    container:document.querySelectorAll(".main-split")[0],
    window_offset:0.0,
    el_start:0,
    el_end:0.7,
    anime:bag_bottom_anime
  })
  rolltide.add(bag_bottom_scroller)





  const bag_anime = anime({
    targets: '.main-split .right .bag',
    easing: 'linear',
    opacity: 1,
    translateY: 25,
    scale:[0.95,1],
    duration: 60,
    autoplay: false
  });
  var bag_scroller = new Scroller({
    id:"spacer",
    container:document.querySelectorAll(".main-split")[0],
    window_offset:0.0,
    el_start:0,
    el_end:0.7,
    anime:bag_anime
  })
  rolltide.add(bag_scroller)



  if (window.box_3d){
    var model_3d_scroller = new Scroller({
      id:"spacer",
      container:document.querySelectorAll(".main-split")[0],
      window_offset:0.0,
      el_start:0,
      el_end:0.5,
      anime:false,
      onprogress: function(prog){
        window.scrub_mixer_to(prog)
      }
    })
  
    rolltide.add(model_3d_scroller)
  
  }



  rolltide.start()






  window_resized()
  window.addEventListener('resize', function(){
    window_resized()
  });

}

function window_resized(){
  if (window.innerWidth <= 980){
    //do some overflow fixing issues
    var win_height = window.innerHeight
    var main_height = document.querySelector('.sticky-container .left').offsetHeight
    var needed_padding_bottom = (main_height - win_height) + 90 + 120 + (win_height/2)
    document.querySelector("#main-split").style.paddingBottom = needed_padding_bottom + "px"
  }
  else {
      //do some overflow fixing issues
      var win_height = window.innerHeight
      var main_height = document.querySelector('.sticky-container .left').offsetHeight
      var needed_padding_bottom = (main_height - win_height) + 90 + 120 // (90 is the header menu offset, plus 120 for breathinig room)
      document.querySelector("#main-split").style.paddingBottom = needed_padding_bottom + "px"
  }


  //update THREE here too
  if (camera && renderer) {
    var box_3d_el = document.querySelector(".box-3d")
    renderer.setSize( box_3d_el.clientWidth, box_3d_el.clientHeight );
    camera.aspect = box_3d_el.offsetWidth / box_3d_el.offsetHeight
    camera.updateProjectionMatrix()
  }
  

}
function start(){

  if (window.box_3d){
    setup_3d()
  }

  setup_scroll_ties()


}

function setup_3d(){
  


  scene = new THREE.Scene();


  renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
  renderer.setPixelRatio( window.devicePixelRatio );
  var box_3d_el = document.querySelector(".box-3d")
  //console.log(box_3d_el)
  renderer.setSize( box_3d_el.clientWidth, box_3d_el.clientHeight );
  renderer.setClearColor( 0xffffff, 0);



  document.querySelectorAll(".box-3d")[0].appendChild( renderer.domElement );
  
  
  
  animation_tick()
  
  
  load_model()

}



function animation_tick() {

  
  requestAnimationFrame( animation_tick );



  if (!camera) {
    return
  }


  // target.x += ( mouseX/50 - target.x) * .05;
  // target.y += ( mouseY/50 - target.y) * .05;
  // target.z = 5 // assuming the camera is located at ( 0, 0, z );

  // if (obj_3d) {
  //   obj_3d.lookAt(target)
  // }
    
  if (controls)
    controls.update()
    


  renderer.render( scene, camera );

}


